module.exports = __webpack_public_path__ + "static/media/better-service.c52ebc48.svg";